//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import jQuery from 'jquery';

export default {
  mounted() {
    // See localStorage documentation here: https://www.w3schools.com/html/html5_webstorage.asp
    var cookiesAccept = localStorage.getItem('cookiesAccept');
    if (!cookiesAccept) {
      localStorage.setItem('cookiesAccept','0');
      jQuery('.cookie-acceptance').show();
    }
    if(cookiesAccept == "1") {
      jQuery('.cookie-acceptance').hide();
    }
    if(cookiesAccept == "0") {
      jQuery('.cookie-acceptance').show();
    }
    jQuery('.cookie-acceptance-icon-wrapper').on('click', function(e) {
      jQuery(this).closest('.cookie-acceptance').remove();
      localStorage.setItem('cookiesAccept','1');
    });

    Equiem.CookieAcceptance({
      el: this.$el.getElementsByClassName('cookie-acceptance')[0]
    });
  }
};



// WEBPACK FOOTER //
// ./app/components/molecules/cookie-acceptance/cookie-acceptance.vue